import { useApolloClient } from '@apollo/client'
import {
  IncentivesCompensationPlansListDocument,
  IncentivesCompensationPlansDataCollectionDocument,
} from 'generated/resources/graphql'
import { useOneMutationSubscription } from 'modules/ai/lib/useOneMutationSubscription'
import { CompensationPlansDataCollection } from 'modules/incentives/pages/CompensationPlansList/CompensationPlansDataCollection'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { useQuery } from 'modules/core/hooks/useQuery'
import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'
import { Box } from '@factorialco/deprecated-design-system'
import i18n from 'modules/core/lib/i18n'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useNavigate } from 'react-router-dom'

const CompensationPlansList = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const apolloClient = useApolloClient()

  const { loading, data, error } = useQuery(IncentivesCompensationPlansListDocument)

  const hasAdditionalCompensations = Boolean(
    data?.incentives.assignableAdditionalCompensationsConnection.totalCount
  )
  const canCreateCompensationPlan =
    data?.incentives?._policies?.compensationPlanCreate?.can ?? false

  const refetchPlans = async () => {
    await apolloClient.refetchQueries({
      include: [
        IncentivesCompensationPlansListDocument,
        IncentivesCompensationPlansDataCollectionDocument,
      ],
    })
  }

  useOneMutationSubscription('UpdateIncentivePlan', refetchPlans)
  useOneMutationSubscription('DeleteIncentivePlan', refetchPlans)

  return (
    <ResponsivePage.Body loading={loading} error={error}>
      {hasAdditionalCompensations ? (
        <CompensationPlansDataCollection canCreate={canCreateCompensationPlan} />
      ) : (
        <Box alignItems="center" justifyContent="center" flexDirection="row" height="full" flexGrow>
          <OneEmptyState
            emoji="⚠️"
            title={i18n.t('incentives.list.empty_additional_compensations.label')}
            description={i18n.t('incentives.list.empty_additional_compensations.description')}
            actions={[
              {
                label: i18n.t('incentives.list.empty_additional_compensations.button'),
                variant: 'outline' as const,
                onClick: () => {
                  navigate(navigation.employees.list.fullPath())
                },
              },
            ]}
          />
        </Box>
      )}
    </ResponsivePage.Body>
  )
}

export default CompensationPlansList
